<htx-table
  [data]="entries"
  [columns]="columnConfig()"
  (rowClicked)="onSelect($event)"
>
</htx-table>

<ng-template #outcomeTemplate let-row>
  <htx-badge
    [text]="'auditLog.outcome.' + row.outcome | transloco"
    [variant]="row.outcome === 'SUCCESS' ? 'success' : 'danger'"
  ></htx-badge>
</ng-template>
